import React from 'react'
import { Container, Typography } from '@cleartrip/ct-design-components'
import { COVERED_ITEMS, CoverageTab, NOT_COVERED_ITEMS } from './constants'
import styles from './VdcEducationPage.module.scss'

interface PolicyCoverageDetailsProps {
  activeTab: CoverageTab
  onTabChange: (tab: CoverageTab) => void
}

const COVERAGE_TABS: CoverageTab[] = ['covered', 'notCovered']
const TAB_LABELS: Record<CoverageTab, string> = {
  covered: '👍 Covered in policy',
  notCovered: '👎 Not covered in policy'
}

const PolicyCoverageDetails: React.FC<PolicyCoverageDetailsProps> = ({ activeTab, onTabChange }) => (
  <Container className={`${styles.coverage} flex flex-column`}>
    <Container className={`${styles['coverage__tabs']} flex`}>
      {COVERAGE_TABS.map((tab) => (
        <Container
          key={tab}
          className={`${styles['coverage__tab']} ${activeTab === tab ? styles['coverage__tab--active'] : styles['coverage__tab--inactive']} c-pointer`}
          onClick={() => onTabChange(tab)}
        >
          <Typography variant="P2" className={`${styles['coverage__tabText']} ${activeTab === tab ? styles['coverage__tabText--active'] : styles['coverage__tabText--inactive']}`}>
            {TAB_LABELS[tab]}
          </Typography>
        </Container>
      ))}
    </Container>
    {activeTab === 'covered' && (
      <Container className={`${styles['coverage__list']} flex flex-column`}>
        {COVERED_ITEMS.map((item) => (
          <Container key={item} className={styles['coverage__listItem']}>
            <Typography variant="P2" className={styles['coverage__listText']}>
              <span className={styles['coverage__bullet']}>•</span>
              {item}
            </Typography>
          </Container>
        ))}
      </Container>
    )}
    {activeTab === 'notCovered' && (
      <Container className={`${styles['coverage__list']} flex flex-column`}>
        {NOT_COVERED_ITEMS.map((item: string) => (
          <Container key={item} className={styles['coverage__listItem']}>
            <Typography variant="P2" className={styles['coverage__listText']}>
              <span className={styles['coverage__bullet']}>•</span>
              {item}
            </Typography>
          </Container>
        ))}
      </Container>
    )}
  </Container>
)

export default PolicyCoverageDetails

